import React, { useEffect, useMemo, useState } from 'react'
import { styles } from './styles'
import './footer.css'
import {
  getLayoutDebuggerMinimized,
  setLayoutDebuggerMinimized,
  subscribeLayoutDebuggerMinimized
} from '../../utils/layout-debugger-visibility'

export const Footer = () => {
  const layoutDebugEnabled = useMemo(() => {
    if (typeof window === 'undefined') return false
    return new URLSearchParams(window.location.search).get('layoutDebug') === '1'
  }, [])

  const [debuggerMinimized, setDebuggerMinimized] = useState(() =>
    layoutDebugEnabled ? getLayoutDebuggerMinimized() : false
  )

  useEffect(() => {
    if (!layoutDebugEnabled) return
    return subscribeLayoutDebuggerMinimized((next) => setDebuggerMinimized(next))
  }, [layoutDebugEnabled])

  return (
    <div style={{ ...styles.box, ...(layoutDebugEnabled ? { zIndex: 6001 } : null) }}>
      <div className='footer-container'>
        <div className='footer-links'>
          <a className='footer-link' href='/kontakt'>
            kontakt
          </a>
          <a className='footer-link' href='/impressum'>
            impresum
          </a>
          <span style={{ display: 'inline-flex', gap: 10, alignItems: 'center' }}>
            <a className='footer-link' href='/datenschutz'>
              škit datow
            </a>
            {layoutDebugEnabled && (
              <button
                type='button'
                className='footer-link'
                onClick={() => setLayoutDebuggerMinimized(!debuggerMinimized)}
                style={{
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer'
                }}
              >
                {debuggerMinimized ? 'Show' : 'Hide'}
              </button>
            )}
          </span>
        </div>
        {/* <p className='footer-text'>
          Projekt spěchuje so wot Załožby za serbski lud přez srědki Zwjazkoweho ministerstwa za
          nutřkowne na zakładźe wobzamknjenja Zwjazkoweho sejma.
        </p> */}
      </div>
    </div>
  )
}
